import { decryptData, encryptData } from "config/config";
import { instance as axios, setMultiPartHeader } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getMasterStates = async (data) => {
  return decryptData(
    await axios.get(
      `/master-states?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addMasterState = async (data) => {
  return decryptData(
    await axios.post(`/master-state-create`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const updateMasterState = async (data) => {
  return decryptData(
    await axios.post(`/master-state-update`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const updateMasterStateStatus = async (data) => {
  return decryptData(
    await axios.get(
      `/master-state-status?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getCityWiseCenters = async (data) => {
  return decryptData(
    await axios.get(
      `/city-wise-center-list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const dropdownMasterStates = async (data) => {
  return decryptData(
    await axios.get(
      `/dropdown-master-states?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const cityWiseCenterCreate = async (data) => {
  return decryptData(
    await axios.post(`/city-wise-center-create`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const cityWiseCenterUpdate = async (data) => {
  return decryptData(
    await axios.post(`/city-wise-center-update`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const cityWiseCenterStatus = async (data) => {
  return decryptData(
    await axios.get(
      `/city-wise-center-status?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getCityWiseBillingCourse = async (data) => {
  return decryptData(
    await axios.get(
      `/get-city-wise-billing-courses?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const mapCityWiseBillingCourses = async (data) => {
  return decryptData(
    await axios.get(
      `/map-city-wise-billing-course?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getCityWiseVideoBanks = async (data) => {
  return decryptData(
    await axios.get(
      `get-city-wise-video-bank?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const mapCityWiseVideo = async (data) => {
  return decryptData(
    await axios.get(
      `/map-city-wise-video-url?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getCityWiseNews = async (data) => {
  return decryptData(
    await axios.get(
      `get-city-wise-news?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const mapCityWiseNews = async (data) => {
  return decryptData(
    await axios.post(`/map-city-wise-news`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const getCityWiseSections = async (data) => {
  return decryptData(
    await axios.get(
      `/get-city-section-details?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getCityDropdown = async (data) => {
  return decryptData(
    await axios.get(
      `/dropdown-city-wise-centers?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const cityWiseSectionCreate = async (data) => {
  return decryptData(
    await axios.post(`/city-wise-sections-create`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const cityWiseSectionUpdate = async (data) => {
  return decryptData(
    await axios.post(`/city-wise-sections-update`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const cityWiseSectionDisplayOrder= async (data) => {
  return decryptData(
    await axios.post(`/city-wise-sections-display-order`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const cityWiseSectionDelete= async (data) => {
  return decryptData(
    await axios.post(`/city-wise-sections-delete`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
// get live lecture courses
export const getLiveLectureCourses = async (data) => {
  return decryptData(
    await axios.get(
      `/live/lecture/course?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getCityWiseTestimonials = async (data) => {
  return decryptData(
    await axios.get(
      `/get-all-state-wise-testimonials?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const mapTestimonials= async (data) => {
  return decryptData(
    await axios.post(`/map-testimonial-for-city`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};